module.exports = __webpack_public_path__ + "img/house01.ca50c841.jpg";